import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ParseService {

  private lang = 'de';

  private packageData: {
    entries: { [key: string]: Models.ContentEntry },
    files: { [key: string]: Models.ContentFile },
    menuItems: { [key: string]: Models.MenuItem },
    ticker: any,
    breakingNews: any,
    screensaver: any,
    votingItem: Models.DynamicContent[],
  } = { entries: {}, files: {}, menuItems: {}, ticker: {}, breakingNews: {}, screensaver: {}, votingItem: null };

  constructor() {
  }

  public parsePackageJSON(json: any, lang = 'de') {
    if (!json) {
      return this.packageData;
    }
    this.lang = lang;
    this.packageData.menuItems = this.parseMenuItems(json.menu);
    this.packageData.entries = this.parseEntries(json.entries);
    this.packageData.files = this.parseFiles(json.files);
    this.packageData.votingItem = this.parseVoting();
    this.packageData.ticker = this.parseMessages(json, json.menu.menus.angieTickerNotifications, 'inw');
    this.packageData.breakingNews = this.parseMessages(json, json.menu.menus.breakingNews, 'bnw');
    const screensaver = this.parseMessages(json, json.menu.menus.screensaver);
    this.packageData.screensaver = screensaver && screensaver.item ? screensaver.item : null;

    return this.packageData;
  }

  public parsePackageApp(json: any) {
    const packageApp = { menuItems: {}, files: {}, entries: {} };
    packageApp.menuItems = this.parseMenuItems(json.menu);
    packageApp.entries = this.parseEntries(json.entries);
    packageApp.files = this.parseFiles(json.files);
    return packageApp;
  }

  public mergeAndOverwriteItems(original: any, additional: any) {
    const merged = original;
    for (const key in additional) {
      if (additional[key]) {
        merged[key] = additional[key];
      }
    }
    return merged;
  }

  public renewTickerBreakingNews(element: any, packageApp: any): any {
    if (packageApp.menuItems[element.item._id]) {
      element.item = Models.ModelFactory.createModelInstanceByName('MenuItem', packageApp.menuItems[element.item._id]);
      element.item.entry = Models.ModelFactory.createModelInstanceByName('ContentEntry', packageApp.entries[element.item.entry]);
      return element;
    }
    return null;
  }

  public parseMenuItems(menu: any): { [key: string]: Models.MenuItem } {
    if (!menu || !menu.items) {
      return {};
    }

    const menuItems: any = {};
    for (const key in menu.items) {
      if (!menu.items.hasOwnProperty(key)) {
        continue;
      }

      let dbKey = key;
      if (_.isArray(menu.items)) {
        dbKey = menu.items[key]._id;
      }
      const rawItemData = menu.items[key];

      const menuItem = new Models.MenuItem();
      if (!menuItem._id) {
        menuItem._id = key;
      }
      menuItem.populateFromJSON(rawItemData);

      menuItems[dbKey] = menuItem;
    }
    return menuItems;
  }

  public parseFiles(files: any): { [key: string]: Models.ContentFile } {
    if (!files) {
      return {};
    }

    const packageFiles: any = {};
    for (const key in files) {
      if (!files.hasOwnProperty(key) || !files[key]) {
        continue;
      }
      let dbKey = key;
      if (_.isArray(files)) {
        dbKey = files[key]._id;
      }
      const rawItemData = files[key];

      const file = new Models.ContentFile();
      file.populateFromJSON(rawItemData);

      packageFiles[dbKey] = file;
    }
    return packageFiles;
  }

  public parseEntries(entries: any): { [key: string]: Models.ContentEntry } {
    if (!entries) {
      return {};
    }
    const menuEntries: any = {};
    for (const key in entries) {
      if (!entries.hasOwnProperty(key)) {
        continue;
      }
      let dbKey = key;
      if (_.isArray(entries)) {
        dbKey = entries[key]._id;
      }
      const rawItemData = entries[key];

      const entry = new Models.ContentEntry();
      if (!entry._id) {
        entry._id = key;
      }
      entry.populateFromJSON(rawItemData);
      entry.lang = this.lang;
      menuEntries[dbKey] = entry;
    }
    return menuEntries;
  }

  parseMessages(json: any, root: any, page?: string) {
    if (!json.menu.items[root.root]) {
      return null;
    }
    const rootMenuItem = json.menu.items[root.root];
    const menuItem = new Models.MenuItem();
    menuItem.populateFromJSON(rootMenuItem);
    if (!menuItem.children && !menuItem.entry) {
      return null;
    }
    const result = { item: menuItem };
    if (!!page) {
      const rootEntry = json.entries[rootMenuItem.entry];
      const entry = new Models.ContentEntry();
      entry.populateFromJSON(rootEntry);
      if (entry.detail) {
        entry.detail.contentType = 'information';
      }
      menuItem.entry = entry as any;
      result['navigationItem'] = { page, entry };
    }
    return result;
  }

  parseVoting(): any {
    for (const key of Object.keys(this.packageData.menuItems)) {
      if (this.packageData.menuItems[key]
        && this.packageData.menuItems[key].children
        && this.packageData.menuItems[key].entry
        && this.packageData.entries[this.packageData.menuItems[key].entry]
        && this.packageData.entries[this.packageData.menuItems[key].entry].detail
        && this.packageData.entries[this.packageData.menuItems[key].entry].detail.contentType === 'voting'
      ) {
        for (let i = 0; i < this.packageData.menuItems.itemMobileApps.children.length; i++) {
          if (this.packageData.menuItems.itemMobileApps.children[i].id === key) {
            this.packageData.menuItems.itemMobileApps.children.splice(i, 1);
          }
        }
        return this.packageData.menuItems[key];
      }
    }
    return null;
  }
}
